import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { pricingActions } from "..";
import { RootState } from "@src/store/store";
import { EventInventoryRecord, getInventoryCacheEventId } from "@src/store/pricing/queryEventInventoryAllSlice";

const initialState = false;

export const { thunk: deleteSchedulePrice, slice: deleteSchedulePriceSlice } = getThunkAndSlice<
	{
		ListingIds: Array<number>;
	},
	typeof initialState
>({
	initialState,
	path: "/api/Pricing/DeleteListingsScheduledPricing",
	method: "delete",
	onAfterRequest: async (data, params, state, dispatch) => {
		const rootState = state as RootState;
		const eventId = getInventoryCacheEventId(rootState);
		const inventoryAllState = rootState.pricing.eventInventoryAll.data;

		const newData = inventoryAllState.map((x) => {
			return params.ListingIds.includes(x.Listing_ID) ? { ...x, Is_Scheduled_Pricing: false } : x;
		});

		dispatch(pricingActions.updateInventoryAll({ data: newData, eventId }));

		if (rootState.pricing.globalInventory.data.length) {
			const newGlobalData = (rootState.pricing.globalInventory.data as Array<EventInventoryRecord>).map((x) => {
				return params.ListingIds.includes(x.Listing_ID) ? { ...x, Is_Scheduled_Pricing: false } : x;
			});
			dispatch(pricingActions.updateGlobalInventory({ data: newGlobalData }));
		}

		return data;
	},
});
